module.exports = __webpack_public_path__ + "assets/img/35a.ae75eef8.jpg";